import { FilterList, FilterListItem } from "react-admin";

export function SidebarFilterBoolean ({label, value}) {
    return (
        <FilterList label={label}>
            <FilterListItem label="Yes" value={{ [value]: true }} />
            <FilterListItem label="No" value={{ [value]: false }} />
        </FilterList>
    );
}